<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
            <v-card-title class="pb-0 subheading">
            Novo endereço:
            </v-card-title>
            <v-card-text class="py-0">
            <div class="xs-12">
                <v-flex xs12>
                    <v-text-field
                    label="Cep"
                    v-model="enderecos.form.novo.cep"
                    ></v-text-field>
                </v-flex>
                  <div class="text-xs-center" v-if="loader.bairrosatendidos">
                    <v-progress-circular
                      indeterminate
                      color="secondary"
                    ></v-progress-circular>
                    <div class="text-xs-center success--text">Carregando bairros...</div>
                  </div>
                <v-autocomplete v-else v-model="enderecos.form.novo.bairro" :items="enderecos.form.novo.bairros" label="Bairro(atendido)" @change="selecionouBairro(enderecos.form.novo.bairro)"></v-autocomplete>
                <template v-if="enderecos.form.novo.bairro=='0' && enderecos.form.novo.bairrosnaoatendidos">
                  <div class="text-xs-center" v-if="loader.bairrosnaoatendidos">
                    <v-progress-circular
                      indeterminate
                      color="secondary"
                    ></v-progress-circular>
                    <div class="text-xs-center success--text">Carregando bairros...</div>
                  </div>
                  <v-flex xs-12 v-else>
                    <v-autocomplete v-model="enderecos.form.novo.bairronovo" :items="enderecos.form.novo.bairrosnaoatendidos" label="Bairro(Solicitar Atendimento)"></v-autocomplete>
                  <!--
                    <v-select v-model="enderecos.form.novo.bairronovo"
                                        :items="enderecos.form.novo.bairrosnaoatendidos"
                                        :label="'Bairro(Solicitar Atendimento)'"
                                      ></v-select>
                    -->
                  </v-flex>
                </template>
                <v-flex xs-12>
                <v-textarea
                    color="teal"
                    rows="3"
                    v-model="enderecos.form.novo.endereco"
                >
                    <template v-slot:label>
                    <div>
                        Endereço
                    </div>
                    </template>
                </v-textarea>
                </v-flex>
                <v-layout>
                <v-flex xs6>
                    <v-text-field
                    label="Número"
                    v-model="enderecos.form.novo.numero"
                    ></v-text-field>
                </v-flex>
                <v-flex xs6>
                    <v-text-field
                    label="Complemento"
                    v-model="enderecos.form.novo.complemento"
                    ></v-text-field>
                </v-flex>
                </v-layout>
            </div>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="dialog=!dialog">Cancelar</v-btn>
            <v-btn color="primary" @click="$emit('cadastrar-novo-endereco',enderecos,'finalizandoPedido')">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import jquery from 'jquery';
export default {
  props: ['baseUrlApi'],
  data: () => ({
    loader: {
      bairrosnaoatendidos: false,
      bairrosatendidos: false
    },
    dialog: false,
    enderecos: {
          form:{
            novo:{
              open: false,
              bairro: null,
              bairronovo: "",
              cep: "",
              endereco: "",
              numero: "",
              complemento: "",
              bairros:[],
              bairrosnaoatendidos:[]
            }
          }
    }
  }),
  methods: {
     selecionouBairro(bairro){
        if(bairro == '0' && this.enderecos.form.novo.bairrosnaoatendidos.length==0){
          console.log('atualizando');
          this.loader.bairrosnaoatendidos = true;
          jquery.get(this.baseUrlApi+'public_negocios/getBairrosNaoAtendidos/forSelect')
          .then(response =>(this.resposta_getBairrosNaoAtendidos(response)));
        }
      },
      resposta_getBairrosNaoAtendidos(response){
        this.loader.bairrosnaoatendidos = false;
        if(response.situacao == true){
          this.enderecos.form.novo.bairrosnaoatendidos = response.dados;
        }
      }
  }
};
</script>